'use client';

import Image from 'next/image';
import { FC } from 'react';
import TextButtonLink from '../../../../components/atoms/TextButtonLink/TextButtonLink';
import ClampedText from '../../../../components/molecules/ClampedText/ClampedText';
import { Author } from '../../../../types/authors';

interface AuthorCardListProps {
  authors: Author[];
}

const AuthorCard = ({
  author: { name, description, slug, simple_local_avatar },
}: {
  author: Author;
}) => {
  return (
    <div className="flex w-full flex-col items-center gap-xl rounded-small border-[1px] border-neutral-200 bg-white px-xl py-l md:flex-row">
      {!!simple_local_avatar?.full && (
        <Image
          src={simple_local_avatar?.full}
          alt={`Avatar of ${name}`}
          className="size-[200px] rounded-full"
          width={200}
          height={200}
        />
      )}

      <div className="flex h-full flex-1 flex-col items-start justify-between gap-s py-[0px] ml:py-[12px]">
        <h4 className="text-h4SemiBold">{name}</h4>
        {!!description && (
          <ClampedText className="text-body1Light" clampLines={4}>
            {description}
          </ClampedText>
        )}
        <TextButtonLink
          href={`/news/author/${slug}`}
          aria-label={`View all of ${name}'s articles`}
          size="medium"
        >
          See my articles
        </TextButtonLink>
      </div>
    </div>
  );
};

export const AuthorCardListClient: FC<AuthorCardListProps> = ({ authors }) => {
  return (
    <div className="flex flex-col gap-xl bg-neutral-100 px-xl py-l ml:grid ml:grid-cols-2 ml:gap-x-xl ml:gap-y-[40px] ml:px-[60px] ml:py-[40px]">
      {authors.map((author) => (
        <AuthorCard key={author.id} author={author} />
      ))}
    </div>
  );
};
